export default () => ({
  getTimes: false,
  to: {
    agenda_id: null,
    schedule_id: null
  },
  errors: {},
  date: null,
  dates: [],
  times: []
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/schedulings/components/transfer/resources/data.js